<div class="p-6 card-style-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-gray-700 font-bold">Atribuir Veículo</h2>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-tab-group>
    <mat-tab label="Meus veículos">
      <div class="pt-4">
        @if (loadingList) {
          <mat-spinner diameter="28" class="loading-spinner"></mat-spinner>
        } @else if (myVehicles.length == 0) {
          <p class="text-sm text-gray-500">Você ainda não tem veículos cadastrados.</p>
        } @else {
          <div class="flex flex-col gap-2 max-h-80 overflow-auto">
            @for (vehicle of myVehicles; track vehicle.id) {
              <div class="flex justify-between items-center border rounded px-3 py-2">
                <div>
                  <div class="font-bold">{{ vehicle.placa }} — {{ vehicle.modelo }} @if (vehicle.ano) {<span class="text-gray-400">({{ vehicle.ano }})</span>}</div>
                  <div class="text-sm text-gray-500">Cor: {{ vehicle.cor || '-' }}</div>
                  <div class="flex flex-wrap gap-1 mt-1">
                    @if (vehicle.seguroVencido) {
                      <span class="chip chip-warning">Seguro vencido</span>
                    } @else if (vehicle.seguroProximoDoVencimento) {
                      <span class="chip chip-warning">Seguro vence em {{ vehicle.diasParaVencimentoSeguro }} dias</span>
                    }
                  </div>
                </div>
                <div class="flex items-center gap-2">
                  <mat-icon class="btn-icon-outline" fontIcon="edit" matTooltip="Editar" (click)="editVehicle(vehicle)" />
                  <mat-icon class="btn-icon-outline" fontIcon="description" matTooltip="Documentos" (click)="openDocuments(vehicle)" />
                  <button
                    mat-flat-button class="btn-tg-white"
                    [disabled]="assigningId == vehicle.id"
                    (click)="assignExisting(vehicle.id)"
                  >
                    @if (assigningId == vehicle.id) {
                      <mat-spinner diameter="18" class="loading-spinner"></mat-spinner>
                    } @else {
                      Selecionar
                    }
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Cadastrar novo">
      <div [formGroup]="form" class="pt-4 flex flex-col gap-3">
        <div class="flex gap-4">
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Placa *</mat-label>
            <input matInput formControlName="placa" [mask]="'AAAAAAA'" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Marca *</mat-label>
            <mat-select [formControl]="marcaControl">
              @for (item of vehicleBrands; track item.id) {
                <mat-option [value]="item.id">{{ item.marca }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Modelo *</mat-label>
            <mat-select formControlName="veiculoModeloId" [disabled]="!marcaControl.value">
              @for (item of filteredVehicleModels; track item.id) {
                <mat-option [value]="item.id">{{ item.modelo }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Tipo de Veículo *</mat-label>
            <mat-select formControlName="tipoVeiculoId">
              @for (item of vehicleTypes; track item.id) {
                <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:140px" appearance="outline">
            <mat-label>Cor *</mat-label>
            <input matInput formControlName="cor" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:110px" appearance="outline">
            <mat-label>Ano</mat-label>
            <input matInput type="number" formControlName="ano" />
          </mat-form-field>
        </div>
        <div class="flex gap-4">
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>CRLV</mat-label>
            <input matInput formControlName="crlv" />
          </mat-form-field>
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Seguro</mat-label>
            <input matInput formControlName="seguro" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Validade seguro</mat-label>
            <input matInput [matDatepicker]="seguroPicker" (focus)="seguroPicker.open()" formControlName="seguroValidade" />
            <mat-datepicker-toggle matIconSuffix [for]="seguroPicker"></mat-datepicker-toggle>
            <mat-datepicker #seguroPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <h4>Documentos (opcional — Licenciamento/CRLV, Seguro)</h4>
        <div class="flex items-end gap-3 flex-wrap">
          <mat-form-field class="input-tg flex-1" appearance="outline" style="min-width:160px">
            <mat-label>Descrição</mat-label>
            <input matInput [(ngModel)]="pendingDescricao" [ngModelOptions]="{ standalone: true }" />
          </mat-form-field>
          <mat-form-field class="input-tg" appearance="outline" style="width:200px">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="pendingTipoDocId" [ngModelOptions]="{ standalone: true }">
              @for (tipo of tipoDocOptions; track tipo.id) {
                <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <input hidden type="file" (change)="onPendingFileSelected($event)" #pendingFileInput accept=".pdf,.jpg,.jpeg,.png" />
          <mat-form-field class="input-tg" appearance="outline" style="width:200px">
            <mat-label>Arquivo</mat-label>
            <input matInput [value]="pendingFile?.name || ''" readonly (click)="pendingFileInput.click()" />
            <button mat-icon-button matSuffix type="button" (click)="pendingFileInput.click()">
              <mat-icon>upload</mat-icon>
            </button>
          </mat-form-field>
          <button
            mat-flat-button class="btn-tg-white"
            type="button"
            [disabled]="!pendingDescricao || !pendingTipoDocId || !pendingFile"
            (click)="addPendingDocument()"
          >
            Adicionar
          </button>
        </div>
        @if (pendingDocuments.length > 0) {
          <div class="flex flex-col gap-1">
            @for (doc of pendingDocuments; track $index) {
              <div class="flex justify-between items-center border rounded px-2 py-1 text-sm">
                <span>{{ doc.tipoDocDescricao }} — {{ doc.descricao }} ({{ doc.arquivo.name }})</span>
                <mat-icon class="btn-icon-outline" fontIcon="close" matTooltip="Remover" (click)="removePendingDocument($index)" />
              </div>
            }
          </div>
        }

        <div class="flex justify-end mt-2">
          <button
            mat-flat-button class="btn-tg"
            [disabled]="form.invalid || creating"
            (click)="createAndAssign()"
          >
            @if (creating) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Cadastrar e atribuir
            }
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
